import {createSelector} from '@reduxjs/toolkit';

const selectAdminSlice = (store) => store.admin;

export const selectCardData = ({cardId, partitionKey}) => {
	return createSelector(selectAdminSlice, (admin) => {
		if (admin[cardId] && admin[cardId].allIds.includes(partitionKey)) {
			return admin[cardId].byId[partitionKey];
		}
		return null;
	});
};

export const selectEditInProgress = createSelector(selectAdminSlice, (admin) => admin.editInProgress);

export const selectMetadata = (cardId) => {
	return createSelector(selectAdminSlice, (admin) => {
		if (admin && admin.metadata && admin.metadata[cardId]) {
			return admin.metadata[cardId];
		}
		return null;
	});
};

export const selectEditableData = ({cardId, partitionKey}) => {
	return createSelector(selectEditInProgress, (editInProgress) => {
		if (editInProgress && editInProgress[cardId] && editInProgress[cardId].allIds.includes(partitionKey)) {
			return editInProgress[cardId].byId[partitionKey];
		}
		return null;
	});
};

export const selectAdminUser = createSelector(selectAdminSlice, (admin) => admin.user);

export const selectAdminUserId = createSelector(selectAdminSlice, (admin) => admin.user.id);

export const selectAdminRoles = createSelector(selectAdminSlice, (admin) => admin.user.systemAdministratorRoleIds ?? []);

export const selectAdministrators = ({cardId}) => {
	return createSelector(selectEditInProgress, (editInProgress) => {
		if (editInProgress && editInProgress[cardId] && editInProgress[cardId].allIds.length > 0) {
			return editInProgress[cardId].allIds.map((id) => editInProgress[cardId].byId[id]);
		}
		return null;
	});
};

export const selectProject = (cardId, projectId) => {
	return createSelector(selectEditInProgress, (slice) => {
		if (slice[cardId] && slice[cardId].allIds.includes(projectId)) {
			return slice[cardId].byId[projectId];
		}

		return null;
	});
};
